<zip-co-header></zip-co-header>

<main>
  <div class="content-max-width back-container">
    <span class="back-btn back-btn-rb" (click)="goToHome()"> All Gift Cards </span>
  </div>
  <div class="container">
    <div class="right">
      <div class="img-error">
        <img src="assets/unsuccessful-cloud.svg" alt="unsuccessful" />
      </div>
      <h1>
        {{ status }}
      </h1>
      <p>
        Looks like there was a technical issue during checkout. We haven't deducted any funds from
        your account. Please try again in a few minutes or
        <a class="link-error-cx" href="https://help.zip.co/hc/en-us">contact customer care.</a>
      </p>

      <p *ngIf="error"><strong>Error: </strong>{{ error }}</p>

      <a class="btn" href="/au/giftcards"> Return to Gift Cards </a>
    </div>
  </div>
</main>

<app-footer></app-footer>
